module.exports = __webpack_public_path__ + "img/Registration-icon.cf9a3fc0.svg";